<template>
  <div>
    <h2 class="font-semibold text-lg mt-4 mb-4 text-[#171717]">
      {{ $t('catalog.templateQuery') }}
    </h2>

    <div class="py-2">
      <SupplierFilter :suppliers="tabs" v-model="activeTab" />
    </div>

    <!-- Templates -->
    <Loader v-if="orderTemplateStore.loading" />
    <div v-else-if="filteredTemplates.length" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 pt-8">
      <template v-for="(template, idx) in filteredTemplates">
        <CatalogTemplateCard :template="template" :isExpanded="isExpanded" @toggleExpanded="isExpanded= !isExpanded" />
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { useOrdersPageStore } from "@/stores/orderTemplateStore";
import Loader from "@/components/atoms/Loader.vue";
import { useI18n } from 'vue-i18n'
import { getLanguage } from '@/utilities/cookies';
import CatalogTemplateCard from './CatalogTemplateCard.vue';
import SupplierFilter from '@/components/SupplierFilter.vue';
const { t, locale } = useI18n()
locale.value = getLanguage();

const orderTemplateStore = useOrdersPageStore();
const activeTab = ref('');
const isExpanded = ref(false);
const tabs = computed(() => orderTemplateStore.brands);
const templates = computed(() => orderTemplateStore.orderTemplateData);

const filteredTemplates = computed(() =>
  templates.value.filter(t => t.brand === activeTab.value)
);

watch(
  () => tabs.value,
  () => activeTab.value = tabs.value[0],
  { once: true }
);

onMounted(() => {
  activeTab.value = tabs.value[0]
})
</script>
